exports.BASE_URI = 'https://apieatlines.smdesigncompany.com/api/';
exports.APP_URI = 'https://admineatlines.smdesigncompany.com';
exports.DEVISE = '€';
exports.BASE_MEDIA =
  'https://apieatlines.smdesigncompany.com/assets/images/medias/';
